/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, October 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import classes from './MultiplePreAuth.module.css';
import closeIcon from "../../../../assets/images/Fireboard/close.png"

const MultiplePreauth = ({
  tickets,
  openTicketDetails,
  onClose,
}) => {

  return (
    <div className={classes.container}>
      <div className={classes.headerWrapper}>
        <div className={classes.backButton} onClick={onClose}>
          <img src={closeIcon} className={classes.backImage} alt="Back" />
        </div>
      </div>
      <Header />
      <div className={classes.contentWrapper}>
        {tickets.map(ticket => (
          <div className={classes.row} key={`ticket-${ticket.id}`}>
            <div className={[classes.contentTxt, classes.typeCol].join(' ')}>{ticket.cardType}</div>
            <div className={[classes.contentTxt, classes.cardCol].join(' ')}>{ticket.redactedCardNumber}</div>
            <div className={[classes.contentTxt, classes.nameCol].join(' ')}>{ticket.cardHolderName}</div>
            <div className={[classes.contentTxt, classes.checkboxCol].join(' ')}>
              <Button
                className={classes.button}
                onClick={() => openTicketDetails(ticket)}>
                SELECT
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default MultiplePreauth;

MultiplePreauth.propTypes = {
  tickets: PropTypes.array,
  openTicketDetails: PropTypes.func,
  onClose: PropTypes.func,
};

MultiplePreauth.defaultProps = {
  tickets: [],
  openTicketDetails: () => { },
  onClose: () => { },
};

const Header = () => (
  <div className={classes.row}>
    <div className={[classes.headerTitle, classes.typeCol].join(' ')}>Card Type</div>
    <div className={[classes.headerTitle, classes.cardCol].join(' ')}>Card#</div>
    <div className={[classes.headerTitle, classes.nameCol].join(' ')}>Card Holder Name</div>
    <div className={[classes.headerTitle, classes.checkboxCol].join(' ')}></div>
  </div>
);
